// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__3wulu","footer":"ReportModalFilter_footer__3nU1j"};